// This file contains getters for AB test group values. Functions should be removed from here as AB tests finish.

import { getABTestGroup } from './shared/getABTestGroup';

export function getEnterFlowProgressValue() {
  return getABTestGroup('EnterFlowProgress');
}

export function getHomePageHeroTextSep2025Value() {
  return getABTestGroup('HomePageHeroTextSep2025');
}

export function getAllPrizesPageTestValue() {
  return getABTestGroup('AllPrizesPage2026');
}

export function getDashboard2026Value() {
  return 'CONTROL'; // Always return control in main (aka drip) branch, use this when ready to deploy: getABTestGroup('Dashboard2026');
}

export function getChooseYourPlanBoostValue() {
  return getABTestGroup('ChooseYourPlanBoost');
}
